import { CommonModule } from '@angular/common';
import { Component, inject } from '@angular/core';
import { Meta, Title } from '@angular/platform-browser';
import { RouterLink } from '@angular/router';

@Component({
	selector: 'app-error-page',
	standalone: true,
	imports: [CommonModule, RouterLink],
	templateUrl: './error-page.component.html',
	styleUrl: './error-page.component.css'
})
export class ErrorPageComponent {
	private title = inject(Title);
	private meta = inject(Meta);
	ngOnInit(): void {
		this.title.setTitle('Página no econtrada');
		this.meta.updateTag({
			name: 'description',
			content:
				'Descubre nuevos destinos con nuestro servicio de viaje en bus. Comodidad y seguridad en cada aventura, en cada trayecto.'
		});
		this.meta.updateTag({
			name: 'og:title',
			content: '¡Destinos Movil Bus! Elige tu siguiente parada y... ¡viaja YA!'
		});
		this.meta.updateTag({
			name: 'og:description',
			content:
				'Descubre nuevos destinos con nuestro servicio de viaje en bus. Comodidad y seguridad en cada aventura, en cada trayecto.'
		});
	}
}
